import { useSelector } from 'react-redux';

import {
  getWishlistsModal,
  getWishlistsNotification,
} from './Wishlists.selectors';

// selectors memoized hooks
export const useWishlistNotificationStateSelector = () => {
  const data = useSelector(getWishlistsNotification);
  return data;
};

export const useWishlistModalStateSelector = () => {
  const data = useSelector(getWishlistsModal);
  return data;
};
